import React from "react";
import { bool } from "prop-types";

import { AGENT_TOOLS_TITLE } from "../constants";
import {
  ItemText,
  ListTitle,
  MenuList,
  MultiLevelMenu
} from "../MultiLevelMenu";

const AgentTools = ({ has_comparables }) => (
  <MultiLevelMenu title={AGENT_TOOLS_TITLE}>
    <ListTitle>{AGENT_TOOLS_TITLE}</ListTitle>
    <MenuList isSubMenu>
      <li>
        <ItemText href="/blog/market-reports">Market Reports</ItemText>
      </li>
      {has_comparables ? (
        <li>
          <ItemText href="/my/comparables">Comparables</ItemText>
        </li>
      ) : null}
      <li>
        <ItemText href="https://streeteasy.com/blog/data-dashboard/">
          Data Dashboard
        </ItemText>
      </li>
    </MenuList>
  </MultiLevelMenu>
);

AgentTools.propTypes = {
  has_comparables: bool
};

AgentTools.defaultProps = {
  has_comparables: false
};

export default AgentTools;
